import React from 'react';

import ItemPresentation from '../dashboard/ItemPresentation';

const PreviewItemPage = (props) => (
  <ItemPresentation sku={props.match.params.sku} />
);

export default PreviewItemPage;
